import React, { useState } from "react";
import { DatePickerProps } from "antd";
import DatePicker from "./DatePicker";
import { Moment } from 'moment';
import { PickerProps } from "antd/lib/date-picker/generatePicker";

type FloatDatePickerProps = PickerProps<Moment> & {
    label: string,
    required?: boolean,
}

const FloatDatePicker = (props: FloatDatePickerProps & DatePickerProps) => {
    const [focus, setFocus] = useState(false);
    let { label, placeholder, required, ...rest } = props;

    if (!placeholder) placeholder = label;

    //   const isOccupied = focus || (value && value.length !== 0);
    const isOccupied = focus || (rest.value);

    const labelClass = isOccupied && label ? "label as-label" : "label as-placeholder";

    const requiredMark = required ? <span className="text-danger">*</span> : null;

    return (
        <div
            className="custom-input"
            onBlur={() => { setFocus(false) }}
            onFocus={() => setFocus(true)}
        >
            <DatePicker {...rest as any} placeholder="" format={rest.format || "dd/MM/y"} />
            {/* <DatePicker {...rest as any} placeholder="" format={(date) => formatInTimeZone(date, 'Asia/Ho_Chi_Minh', "dd/MM/yyyy")} /> */}
            <label className={labelClass}>
                {isOccupied ? label : placeholder} {requiredMark}
            </label>
        </div>
    );
};

export default FloatDatePicker;
